import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class DeleteDocument {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteDocument;
